import async from '~/utils/async';
import RootStoreContext from '~/contexts/RootStoreContext';
import resolver from './TopRankMetricsLayout.resolver';
import TopRankMetricsLayout from './TopRankMetricsLayout';

export default async(resolver, { context: RootStoreContext })(
  TopRankMetricsLayout
);
